const drivers = {
  drivers: 'Fahrer',
  createNew: 'Neu',

  headerButtons: {
    create: {
      createBtn: 'Erstellen',
    },

    import: 'Importieren',
  },

  import: {
    title: 'Fahrer-Upload',
  },

  toast: {
    error: {
      badResponse: '[Driver] fehlerhafte Serverantwort',
      create: {},
      edit: {},
    },
    success: {
      create: {},
      edit: {},
    },
  },
  table: {
    headers: {
      displayName: 'Name',
      name: 'Name',
      driverStatus: 'Status',
      email: 'E-Mail',
      vehicle: 'Fahrzeug',
      phoneNumber: 'Telefonnummer',
      address: 'Adresse',
      firstTripDistance: 'Maximale Entfernung der 1. Fahrt',
      action: 'Aktion',
      attributes: 'Eigenschaften',
      locations: 'Standorte',
      areas: 'Zonen',
      excludedProfiles: 'Ausgeschlossene Profile',
    },
    statusOptions: {
      online: 'Online',
      offline: 'Offline',
      break: 'Pause',
      enRoute: 'Unterwegs',
      suspended: 'Gesperrt',
    },
    viewOptions: {
      showSuspended: 'Gesperrte anzeigen',
      showUnsuspended: 'Nicht Gesperrte anzeigen',
    },
    filters: {
      status: 'Status',
      vehicles: 'Fahrzeuge',
      services: 'Leistungen',
      suppliers: 'Anbieter',
      attributes: 'Eigenschaften',
      areas: 'Zonen',
      locations: 'Standorte',
      airportLocations: 'Flughafenstandorte',
    },
    actions: {
      delete: 'Löschen',
      export: 'Exportieren',
    },
    toolTip: {
      noPermission: 'Aktion nicht zulässig: Berechtigung erforderlich',
    },
  },

  create: {
    submit: {
      success: 'Fahrer wurde erfolgreich erstellt',
      error: 'Der Fahrer konnte aufgrund eines internen Serverfehlers nicht erstellt werden.',
    },
  },

  update: {
    submit: {
      success: 'Fahrer wurde erfolgreich aktualisiert',
      error: 'Der Fahrer konnte aufgrund eines internen Serverfehlers nicht aktualisiert werden.',
    },
    formTabs: {
      informationTab: 'Information',
      notesTab: 'Hinweise',
      historyTab: 'Geschichte',
      reservationPreferencesTab: 'Reservierungspräferenzen',
    },
    toast: {
      toastResetSuccess: 'Die E-Mail zum Zurücksetzen des Passworts wurde erfolgreich gesendet.',
      toastError: 'please try again.,Etwas ist schiefgelaufen, bitte versuchen Sie es erneut., please try again.',
      toastRemoveDriverSuccess: 'Fahrer erfolgreich gelöscht',
    },
    driverStatusOptions: {
      activate: 'Aufheben der Sperre',
      deactivate: 'Sperren',
      statusActive: 'Aktiv',
      statusInactive: 'Inaktiv',
      statusOffline: 'Offline',
      statusOnline: 'Online',
      statusEnRoute: 'Unterwegs',
      statusBreak: 'Pause',
      popUpOptions: {
        popupTitleActive: 'Fahrer sperren',
        popupTitleDeactivation: 'Fahrer entsperren',
        popupTitleUnsuspend: 'Grund für die Aufhebung der Sperrung',
        popupSubTitleDeactivation: 'Wählen Sie den Grund für die Sperrung aus',
        popupActionActive: 'Fahrer entsperren',
        popupActionDeactivate: 'Fahrer sperren',
      },
    },
    modalRemoveConfirm: {
      header: 'Warnung!',
      body: 'Möchten Sie diesen Fahrer wirklich löschen?',
      confirmBtn: 'Löschen',
    },
  },
  deleteModal: {
    header: 'Fahrer löschen',
    body: 'Sie sind dabei, {{num}} Fahrer zu löschen.',
    success: 'Fahrer wurden erfolgreich gelöscht',
  },

  forms: {
    header: {
      createDriver: {
        title: 'Erstellen',
      },

      updateDriver: {
        title: 'Aktualisieren',
      },
    },

    footer: {
      confirmButtonText: {
        create: 'Einreichen',
        update: 'Einreichen',
      },
    },

    information: {
      personalDetails: {
        header: 'Persönliche Daten',
        fields: {
          firstName: 'Vorname',
          lastName: 'Nachname',
          name: 'Namen anzeigen',
          phone: 'Telefonnummer',
          email: 'E-Mail-Adresse',
          password: 'Passwort',
        },
      },

      areaSettings: {
        header: 'Zoneneinstellungen',
        fields: {
          areas: 'Zonen',
          mode: 'Modus',
          priority: 'Priorität',
          modeOptions: {
            allStops: 'Alle Haltestellen',
            firstPickDrop: 'Erste Abholung / Letzter Ausstieg',
            legAOrigin: 'Leg A Origin',
          },
          priorityOptions: {
            low: 'Niedrig',
            medium: 'Medium',
            high: 'Hoch',
            strict: 'Strikt',
          },
        },
        locationsSettings: {
          header: 'Konfigurationen von Standorten',
          fields: {
            locations: 'Standorte',
            enableInBetweenRides: 'Zwischenfahrten aktivieren',
          },
        },
      },

      locationsSettings: {
        header: 'Standorteinstellungen',
        fields: {
          locations: 'Standorte',
          enableInBetweenRides: 'Zwischenfahrten aktivieren',
        },
      },

      vehicles: {
        header: 'Zugewiesene Fahrzeuge',
        fields: {
          available: 'Verfügbare Fahrzeuge',
          current: 'Aktuelles Fahrzeug',
        },
      },
      address: {
        header: 'Startadresse',
        fields: {
          mainAddress: 'Hauptadresse',
          firstTripDistance: 'Maximale Entfernung der 1. Fahrt',
          alt: 'Alternative Adresse',
        },
      },
      settings: {
        header: 'Zusätzliche Einstellungen',
        fields: {
          services: 'Leistungen',
          areas: 'Zonen',
          externalId: 'Externe ID',
          ignoreDropoffTime: 'Ignore Drop-Off Time',
          ignoreDropoffTimeOptions: {
            bySystemSettings: 'Nach Systemeinstellungen',
            enabled: 'Aktiviert',
            disabled: 'Deaktiviert',
          },
          shiftBuffer: 'Shift Buffer',
        },
      },
      supplier: {
        header: 'Anbieter',
        fields: {
          suppliers: 'Anbieter',
        },
      },
      allowSharedRides: {
        header: 'Gemeinsame Fahrten zulassen',
        fields: {
          allowSharedRides: 'Gemeinsame Fahrten zulassen',
        },
      },
      attributes: {
        header: 'Eigenschaften',
      },
      excludedProfiles: {
        header: 'Ausgeschlossene Profile',
        dualList: {
          profilesList: {
            header: 'Profilliste',
          },
          excludedList: {
            header: 'Ausgeschlossene Profile',
          },
        },
      },
      buttons: {
        btnResetPassword: 'Passwort zurücksetzen',
        btnDelete: 'Löschen',
      },
    },
  },
};

export default drivers;
